import React, { useCallback } from 'react';
import { useField } from 'formik';
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material';

function RadioGroupInput({ label, options = [], labelKey = 'label', valueKey = 'value', ...props }) {
    return (
        <FormControl>
            <FormLabel id="demo-radio-buttons-group-label">{label}</FormLabel>
            <RadioGroup aria-labelledby="demo-radio-buttons-group-label" {...props}>
                <>
                    {options.map((option) => (
                        <FormControlLabel value={option?.[valueKey] ?? ''} control={<Radio />} label={option?.[labelKey] ?? ''} />
                    ))}
                </>
            </RadioGroup>
        </FormControl>
    );
}

const MemonizedRadioGroupInput = React.memo(RadioGroupInput);

function RadioGroupField(props) {
    const [field, meta, helpers] = useField(props);

    const handleOnChange = useCallback((event) => {
        helpers.setValue(event.currentTarget.value);
    }, []);

    return <MemonizedRadioGroupInput {...field} {...props} onChange={handleOnChange} />;
}

export default RadioGroupField;
